var _circle, _path, _path2, _path3, _path4, _path5, _rect, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdentification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 89,
    viewBox: "0 0 84 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.9046,
    cy: 38.6957,
    r: 37.1478,
    stroke: "#070707",
    strokeWidth: 3.09565
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3175 23.2188H21.4914C20.4229 23.2188 19.5566 24.085 19.5566 25.1535V52.2405C19.5566 53.309 20.4229 54.1753 21.4914 54.1753H56.3175C57.3861 54.1753 58.2523 53.309 58.2523 52.2405V25.1535C58.2523 24.085 57.3861 23.2188 56.3175 23.2188Z",
    stroke: "black",
    strokeWidth: 3.09565,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1332 39.661C34.2703 39.661 36.0028 37.9285 36.0028 35.7914C36.0028 33.6544 34.2703 31.9219 32.1332 31.9219C29.9962 31.9219 28.2637 33.6544 28.2637 35.7914C28.2637 37.9285 29.9962 39.661 32.1332 39.661Z",
    stroke: "black",
    strokeWidth: 3.09565,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9368 45.4684C37.9368 42.2628 35.3381 39.6641 32.1325 39.6641C28.9268 39.6641 26.3281 42.2628 26.3281 45.4684",
    stroke: "black",
    strokeWidth: 3.09565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7744 34.8281H50.5135",
    stroke: "black",
    strokeWidth: 3.09565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.709 42.5703H50.5133",
    stroke: "black",
    strokeWidth: 3.09565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.5137,
    y: 55.7188,
    width: 33.2783,
    height: 33.2783,
    rx: 16.6391,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4753 85.7788C59.8172 85.7788 53.6094 79.571 53.6094 71.9128C53.6094 64.2547 59.8172 58.0469 67.4753 58.0469C75.1335 58.0469 81.3413 64.2547 81.3413 71.9128C81.3413 79.571 75.1335 85.7788 67.4753 85.7788ZM67.4753 83.0056C70.4173 83.0056 73.2388 81.8369 75.3191 79.7566C77.3994 77.6763 78.5681 74.8548 78.5681 71.9128C78.5681 68.9708 77.3994 66.1494 75.3191 64.0691C73.2388 61.9888 70.4173 60.8201 67.4753 60.8201C64.5333 60.8201 61.7119 61.9888 59.6316 64.0691C57.5513 66.1494 56.3826 68.9708 56.3826 71.9128C56.3826 74.8548 57.5513 77.6763 59.6316 79.7566C61.7119 81.8369 64.5333 83.0056 67.4753 83.0056ZM67.4753 64.9798C67.8431 64.9798 68.1958 65.1259 68.4558 65.386C68.7158 65.646 68.8619 65.9987 68.8619 66.3664V73.2994C68.8619 73.6672 68.7158 74.0198 68.4558 74.2799C68.1958 74.5399 67.8431 74.686 67.4753 74.686C67.1076 74.686 66.7549 74.5399 66.4948 74.2799C66.2348 74.0198 66.0887 73.6672 66.0887 73.2994V66.3664C66.0887 65.9987 66.2348 65.646 66.4948 65.386C66.7549 65.1259 67.1076 64.9798 67.4753 64.9798ZM67.4753 78.8458C67.1076 78.8458 66.7549 78.6997 66.4948 78.4397C66.2348 78.1796 66.0887 77.8269 66.0887 77.4592C66.0887 77.0914 66.2348 76.7388 66.4948 76.4787C66.7549 76.2187 67.1076 76.0726 67.4753 76.0726C67.8431 76.0726 68.1958 76.2187 68.4558 76.4787C68.7158 76.7388 68.8619 77.0914 68.8619 77.4592C68.8619 77.8269 68.7158 78.1796 68.4558 78.4397C68.1958 78.6997 67.8431 78.8458 67.4753 78.8458Z",
    fill: "#F83758"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentification);
export default __webpack_public_path__ + "static/media/identification.5ba11b79d193c6af10e30967d036e409.svg";
export { ForwardRef as ReactComponent };